"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemshotButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const room_session_1 = require("../../../../context/room_session");
const sdk_core_1 = require("@streem/sdk-core");
const toolbar_button_1 = require("./toolbar_button");
function StreemshotButton({ disabled, addNotification }) {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [requestTimedOut, setRequestTimedOut] = (0, react_1.useState)(false);
    const [requesting, setRequesting] = (0, react_1.useState)(false);
    const getLabel = (0, react_1.useCallback)(() => {
        let msg;
        if (requestTimedOut) {
            msg = 'Streemshot error. Click to retry.';
        }
        else {
            msg = 'Take a Streemshot';
        }
        return msg;
    }, [requestTimedOut]);
    const requestStreemshot = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const id = roomSession.streemshots.requestStreemshot();
        try {
            setRequestTimedOut(false);
            setRequesting(true);
            yield (0, sdk_core_1.artifactTimedResponse)(id, roomSession.streemshots.responses);
            setRequesting(false);
            addNotification(id);
        }
        catch (error) {
            setRequestTimedOut(true);
            setRequesting(false);
            setTimeout(() => {
                setRequestTimedOut(false);
            }, 3000);
        }
    }), [roomSession.streemshots]);
    return ((0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { "data-testid": "streemshot-button", showErrorMsg: requestTimedOut, iconName: "NewStreemshotsIcon", label: getLabel(), onClick: requestStreemshot, loading: requesting, disableButton: disabled, disableTooltip: disabled || requesting }));
}
exports.StreemshotButton = StreemshotButton;
//# sourceMappingURL=streemshot_button.js.map